var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('psi-card-heading',{attrs:{"headingTitle":"Events","icon":"mdi-calendar-clock"}}),_c('psi-simple-table',{attrs:{"height":"350","fixed":"","dense":"","items":_vm.caseDetails.case.events,"headers":_vm.headers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }